import { render, staticRenderFns } from "./sideSchedule.vue?vue&type=template&id=1152dbc8&scoped=true&"
import script from "./sideSchedule.vue?vue&type=script&lang=js&"
export * from "./sideSchedule.vue?vue&type=script&lang=js&"
import style0 from "./sideSchedule.vue?vue&type=style&index=0&id=1152dbc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152dbc8",
  null
  
)

export default component.exports